




























































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import BaseView from "@/components/BaseView.vue";
import { validate, format } from "rut.js";

@Component({
  components: {
    BaseView
  }
})
export default class UserNew extends Vue {
  // Vuex store with lightweight typed wrapper
  readonly store = this.$store.direct;
  // Component constants
  title: string = "Nuevo usuario";
  subtitle: string = "Crear un nuevo usuario";
  info = null;

  valid = false;

  master = {
    email: "",
    full_name: "",
    rut: "",
    is_admin: false,
    auto_password: true,
    password: "",
    confirm_password: ""
  };

  rules = {
    required: (v: string) => (v && v.length > 0) || "Campo requerido",
    min: (v: string) => v.length > 6 || "Mínimo 6 carácteres",
    confirmation: (p: string) =>
      p == this.master.password || "Las contraseñas no coinciden",
    rut: (r: string) => validate(r) || "Rut no válido"
  };

  get rut() {
    return this.master.rut;
  }

  get editing() {
    return !!this.$route.params.id;
  }

  get isAdmin() {
    return this.sessionUser && this.sessionUser.attributes.is_admin;
  }

  set rut(val: string) {
    this.master.rut = format(val);
  }

  get sessionUser() {
    return this.store.state.session.user;
  }

  cancel() {
    this.$router.push({ path: "/users" });
  }

  async create() {
    let payload = { ...this.master };
    if (payload.auto_password)
      payload.password = Math.random()
        .toString(36)
        .slice(2);
    let result = await this.store.dispatch.user.create(payload);
    if (result.error) {
      this.store.commit.PUSH_MESSAGE({
        message: "No se pudo crear el usuario. Intente nuevamente.",
        type: "error"
      });
    } else {
      this.store.commit.PUSH_MESSAGE({
        message: "El usuario se ha creado correctamente.",
        type: "success"
      });
      this.store.commit.user.CLEAR_SELECTED();
      this.$router.push("/users");
    }
  }

  async update() {
    let payload = { ...this.master };
    let result = await this.store.dispatch.user.update({
      id: this.$route.params.id,
      payload
    });
    if (result.error) {
      this.store.commit.PUSH_MESSAGE({
        message: "No se pudo guardar el usuario. Intente nuevamente.",
        type: "error"
      });
    } else {
      this.store.commit.PUSH_MESSAGE({
        message: "El usuario se ha guardado correctamente.",
        type: "success"
      });
      this.store.commit.user.CLEAR_SELECTED();
      this.$router.push("/users");
    }
  }
  // Runs on component creation
  async created() {
    if (this.$route.params.id) {
      let res = await this.store.dispatch.user.find(this.$route.params.id);
      if (res.data) {
        this.master = {
          email: res.data.attributes.email,
          full_name: res.data.attributes.full_name || "",
          rut: res.data.attributes.rut || "",
          is_admin: res.data.attributes.is_admin,
          auto_password: true,
          password: "",
          confirm_password: ""
        };
      }
    }
  }

  @Watch("master.auto_password")
  onAutoPasswordChange(newVal: boolean, oldVal: boolean) {
    if (newVal) {
      this.master.password = "";
      this.master.confirm_password = "";
    }
  }
}
